"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtensionKVStore = void 0;
const base_1 = require("./base");
const ExtensionKVStoreProvider = {
    get: typeof browser !== "undefined"
        ? browser.storage.local.get
        : undefined,
    set: typeof browser !== "undefined"
        ? browser.storage.local.set
        : undefined,
};
class ExtensionKVStore extends base_1.BaseKVStore {
    constructor(prefix) {
        super(ExtensionKVStoreProvider, prefix);
    }
}
exports.ExtensionKVStore = ExtensionKVStore;
//# sourceMappingURL=extension.js.map